<template>
  <div class="container">
    <header class="jumbotron">
        <p>Applicant</p>
      <h3>{{content}}</h3>
    </header>
  </div>
</template>

<script>
import UserService from '../../services/user.service';

export default {
  name: 'Applicant',
  data() {
    return {
      content: ''
    };
  },
  mounted() {
    UserService.getUserBoard().then(
      response => {
        this.content = response.data;
      },
      error => {
        this.content =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();
      }
    );
  }
};
</script>
